
class SecurityService {

    tokenKey = "token";

    logout() {
        localStorage.removeItem(this.tokenKey)
    }

    setAccessToken(token) {
        localStorage.setItem(this.tokenKey, token)
    }

    getAccessToken() {
        return localStorage.getItem(this.tokenKey)
    }

    isAuth() {
        return !!this.getAccessToken();
    }

}
var securityService = new SecurityService();
export default securityService;